"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BankAccountValidator_1 = __importDefault(require("./BankAccountValidator"));
exports.default = BankAccountValidator_1.default;
//# sourceMappingURL=index.js.map